import request from '@/utils/request'

const userBalanceDetails = {
  name: 'userBalanceDetails',
  state: {
    isUserBalanceDetailsDetailLoading: false,
    userBalanceDetailsDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_USERBALANCEDETAILS_DETAIL_LOADING: (state, data) => {
      state.isUserBalanceDetailsDetailLoading = data
    },
    SET_MODULES_USERBALANCEDETAILS_DETAIL_DATA: (state, data) => {
      state.userBalanceDetailsDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryUserBalanceDetailsDetailData({ commit }, id) {
      commit('SET_IS_MODULES_USERBALANCEDETAILS_DETAIL_LOADING', true)
      commit('SET_MODULES_USERBALANCEDETAILS_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/userBalanceDetails/userBalanceDetailsDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_USERBALANCEDETAILS_DETAIL_LOADING', false)
          commit('SET_MODULES_USERBALANCEDETAILS_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_USERBALANCEDETAILS_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetUserBalanceDetailsDetailData({ commit }) {
      commit('SET_MODULES_USERBALANCEDETAILS_DETAIL_DATA', {})
    }
  }
}

export default userBalanceDetails
